import { useEffect, useState } from 'react'

import { toRiskifiedSessionId } from '@/utils/functions/slugify'

export function useRiskifiedScript(
  userId: string,
  cartId: string,
  storeDomain: string,
) {
  const [isRiskXLoaded, setIsRiskXLoaded] = useState(false)

  useEffect(() => {
    const sessionId = toRiskifiedSessionId(userId, cartId)
    let script: HTMLScriptElement | null = null
    if (!isRiskXLoaded && cartId) {
      const protocol =
        document.location.protocol === 'https:' ? 'https://' : 'http://'
      const url = `${protocol}beacon.riskified.com?shop=${storeDomain}&sid=${sessionId}`
      script = document.createElement('script')

      script.type = 'text/javascript'
      script.async = true
      script.src = url
      script.addEventListener('load', () => {
        setIsRiskXLoaded(true)
      })
      document.head.append(script)
    }
    return () => {
      script?.remove()
    }
  }, [isRiskXLoaded, storeDomain, userId, cartId])

  return isRiskXLoaded
}
